import React, { FC } from 'react';

export const Information: FC = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" width="24" height="24" viewBox="0 0 24 24">
    <path fill="#005950" d="M20.25 12a8.25 8.25 0 1 0-16.5 0 8.25 8.25 0 0 0 16.5 0m-9.294-1.441c1.146-.573 2.437.462 2.126 1.705l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.041.021c-1.146.574-2.437-.461-2.126-1.705l.709-2.836-.042.02a.75.75 0 0 1-.67-1.34zM12.008 7.5a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75H12a.75.75 0 0 1-.75-.75V8.25A.75.75 0 0 1 12 7.5zM21.75 12A9.75 9.75 0 0 1 12 21.75 9.75 9.75 0 0 1 2.25 12 9.75 9.75 0 0 1 12 2.25 9.75 9.75 0 0 1 21.75 12"/>
  </svg>
);
